import { useState, useEffect, useContext } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import TopNavBar from '../components/navigation/TopNavBar'
import SectionHeaderView from '../components/views/SectionHeaderView'
import DatePickerInput from '../components/inputs/DatePickerInput'
import DropdownInput from '../components/inputs/DropdownInput'
import TextAreaInput from '../components/inputs/TextAreaInput'
import FormInput2 from '../components/inputs/FormInput2'
import RoundedButton from '../components/buttons/RoundedButton'
import RoundedBorderButton from '../components/buttons/RoundedBorderButton'
import ConfirmModal from '../components/modals/ConfirmModal'
import LoadingModal from '../components/modals/LoadingModal'
import * as Constants from '../utils/constants'
import dayjs from 'dayjs'
import { UserContext } from '../App'
import { isExpired } from 'react-jwt'
import { ToastContainer, toast } from 'react-toastify'
import arrow from '../assets/arrow.png'
import arrowDown from '../assets/arrow-down-accent.png'
import arrowUp from '../assets/arrow-up-accent.png'
import strings from '../res/strings'
import 'react-toastify/dist/ReactToastify.css'

const SuggestSchedule = () => {
    const { id } = useParams()

    const [schedule, setSchedule] = useState(null)

    const [maxDate, setMaxDate] = useState(null)
    const [excludedDates, setExcludedDates] = useState([])

    const [putToDryDate, setPutToDryDate] = useState(null)
    const [putToDryDateError, setPutToDryDateError] = useState(null)
    const [putToDryDateSelected, setPutToDryDateSelected] = useState(false)
    const [selectedPutToDryStartTime, setSelectedPutToDryStartTime] = useState({})

    const [putToSwimDate, setPutToSwimDate] = useState(null)
    const [putToSwimDateError, setPutToSwimDateError] = useState(null)
    const [putToSwimDateSelected, setPutToSwimDateSelected] = useState(false)
    const [selectedPutToSwimStartTime, setSelectedPutToSwimStartTime] = useState({})

    const [stayStartDate, setStayStartDate] = useState(null)
    const [stayEndDate, setStayEndDate] = useState(null)

    const [lineChangeDate, setLineChangeDate] = useState(null)
    const [lineChangeDateError, setLineChangeDateError] = useState(null)
    const [lineChangeDateSelected, setLineChangeDateSelected] = useState(false)
    const [selectedLineChangeStartTime, setSelectedLineChangeStartTime] = useState({})

    const [supplyPersonnelDate, setSupplyPersonnelDate] = useState(null)
    const [supplyPersonnelDateError, setSupplyPersonnelDateError] = useState(null)
    const [supplyPersonnelDateSelected, setSupplyPersonnelDateSelected] = useState(false)
    const [selectedSupplyPersonnelStartTime, setSelectedSupplyPersonnelStartTime] = useState({})
    const [selectedSupplyPersonnelEndTime, setSelectedSupplyPersonnelEndTime] = useState({})
    const [numberOfMen, setNumberOfMen] = useState('0')

    const [rippingServiceDescription, setRippingServiceDescription] = useState('')
    const [rippingDate, setRippingDate] = useState(null)
    const [rippingDateError, setRippingDateError] = useState(null)
    const [rippingDateSelected, setRippingDateSelected] = useState(false)
    const [selectedRippingStartTime, setSelectedRippingStartTime] = useState({})
    const [selectedRippingEndTime, setSelectedRippingEndTime] = useState({})
    
    const [supplyPersonnelExpanded, setSupplyPersonnelExpanded] = useState(false)
    const [rippingExpanded, setRippingExpanded] = useState(false)

    const [mooringStartDate, setMooringStartDate] = useState(null)
    const [mooringStartDateError, setMooringStartDateError] = useState(null)
    const [mooringStartDateSelected, setMooringStartDateSelected] = useState(false)

    const [mooringEndDate, setMooringEndDate] = useState(null)
    const [mooringEndDateError, setMooringEndDateError] = useState(null)
    const [mooringEndDateSelected, setMooringEndDateSelected] = useState(false)

    const [contractedPower, setContractedPower] = useState('')
    const [electricitySupplyDate, setElectricitySupplyDate] = useState(null)
    const [electricitySupplyDateError, setElectricitySupplyDateError] = useState(null)

    const [rescheduleReason, setRescheduleReason] = useState('')

    const [showSuggestModal, setShowSuggestModal] = useState(false)

    const [isLoading, setIsLoading] = useState(true)

    const { loggedUser, setLoggedUser } = useContext(UserContext)
    const navigate = useNavigate()

    useEffect(() => {
        if(loggedUser !== null && loggedUser !== 'refresh') {
            const isTokenExpired = isExpired(loggedUser.jwtToken)

            if(isTokenExpired) {
                setLoggedUser(null)
                navigate('/')
            } else if(loggedUser.role === Constants.Roles.CLIENT) {
                navigate('/')
            } else {
                const today = new Date()
                const oneYearLater = new Date()
                oneYearLater.setFullYear(today.getFullYear() + 1)

                setMaxDate(dayjs(oneYearLater))

                getScheduleDetails()
            }
        } else if (loggedUser === null) {
            navigate('/')
        }
    }, [loggedUser])

    // Handle get schedule details
    const getScheduleDetails = () => {
        fetch(`/api/Schedule/${id}/Details`, {
            method:'GET',
            headers: { 
              'Accept': 'application/json',
              'Content-Type': 'application/json; charset=UTF-8',
              'Authorization': 'Bearer ' + loggedUser.jwtToken
            }, 
            mode: 'cors'
        }).then(async response => {
            setTimeout(async () => {
                setIsLoading(false)

                if (response.status === 200) {
                    const jsonRes = await response.json()
                    
                    setSchedule(jsonRes)
                    getExcludedDates(jsonRes.harborId)
                    
                    if(jsonRes.scheduleTypeId === Constants.ScheduleTypes.FAIRING || jsonRes.scheduleTypeId === Constants.ScheduleTypes.FAIRINGENERGY) {
                        setPutToDryDate(jsonRes.dryStartDate ? dayjs(jsonRes.dryStartDate) : null)
                        setPutToDryDateSelected(jsonRes.dryStartDate ? true : false)
                        const dryStartTime = jsonRes.dryStartDate ? formatTime(jsonRes.dryStartDate) : null
                        setSelectedPutToDryStartTime(dryStartTime ? Constants.TIMES.find(time => time.label === dryStartTime) : {})
                        
                        setPutToSwimDate(jsonRes.swimStartDate ? dayjs(jsonRes.swimStartDate) : null)
                        setPutToSwimDateSelected(jsonRes.swimStartDate ? true : false)
                        const swimStartTime = jsonRes.swimStartDate ? formatTime(jsonRes.swimStartDate) : null
                        setSelectedPutToSwimStartTime(swimStartTime ? Constants.TIMES.find(time => time.label === swimStartTime) : {})

                        setStayStartDate(jsonRes.startDate ? dayjs(jsonRes.startDate) : null)
                        setStayEndDate(jsonRes.endDate ? dayjs(jsonRes.endDate) : null)
    
                        setLineChangeDate(jsonRes.lineChangeStartDate ? dayjs(jsonRes.lineChangeStartDate) : null)
                        setLineChangeDateSelected(jsonRes.lineChangeStartDate ? true : false)
                        const lineChangeStartTime = jsonRes.lineChangeStartDate ? formatTime(jsonRes.lineChangeStartDate) : null
                        setSelectedLineChangeStartTime(lineChangeStartTime ? Constants.TIMES.find(time => time.label === lineChangeStartTime) : {})
                        
                        setSupplyPersonnelDate(jsonRes.supplyPersonnelStartDate ? dayjs(jsonRes.supplyPersonnelStartDate) : null)
                        setSupplyPersonnelDateSelected(jsonRes.supplyPersonnelStartDate ? true : false)
                        const supplyPersonnelStartTime = jsonRes.supplyPersonnelStartDate ? formatTime(jsonRes.supplyPersonnelStartDate) : null
                        setSelectedSupplyPersonnelStartTime(supplyPersonnelStartTime ? Constants.TIMES.find(time => time.label === supplyPersonnelStartTime) : {})
                        const supplyPersonnelEndTime = jsonRes.supplyPersonnelEndDate ? formatTime(jsonRes.supplyPersonnelEndDate) : null
                        setSelectedSupplyPersonnelEndTime(supplyPersonnelEndTime ? Constants.TIMES.find(time => time.label === supplyPersonnelEndTime) : {})
                        setNumberOfMen(jsonRes.supplyPersonnel ? jsonRes.supplyPersonnel.toString() : '0')

                        if(jsonRes.supplyPersonnelStartDate || jsonRes.supplyPersonnelEndDate || jsonRes.supplyPersonnel) {
                            setSupplyPersonnelExpanded(true)
                        }
    
                        setRippingServiceDescription(jsonRes.rippingDescription)
                        setRippingDate(jsonRes.rippingStartDate ? dayjs(jsonRes.rippingStartDate) : null)
                        setRippingDateSelected(jsonRes.rippingStartDate ? true : false)
                        const rippingStartTime = jsonRes.rippingStartDate ? formatTime(jsonRes.rippingStartDate) : null
                        setSelectedRippingStartTime(rippingStartTime ? Constants.TIMES.find(time => time.label === rippingStartTime) : {})
                        const rippingEndTime = jsonRes.rippingEndDate ? formatTime(jsonRes.rippingEndDate) : null
                        setSelectedRippingEndTime(rippingEndTime ? Constants.TIMES.find(time => time.label === rippingEndTime) : {})
                    }
    
                    if(jsonRes.scheduleTypeId === Constants.ScheduleTypes.MOORING || jsonRes.scheduleTypeId === Constants.ScheduleTypes.MOORINGENERGY) {
                        setMooringStartDate(jsonRes.startDate ? dayjs(jsonRes.startDate) : null)
                        setMooringStartDateSelected(jsonRes.startDate ? true : false)
                        setMooringEndDate(jsonRes.endDate ? dayjs(jsonRes.endDate) : null)
                        setMooringEndDateSelected(jsonRes.endDate ? true : false)
                    }
    
                    if(jsonRes.scheduleTypeId === Constants.ScheduleTypes.FAIRINGENERGY || jsonRes.scheduleTypeId === Constants.ScheduleTypes.MOORINGENERGY || jsonRes.scheduleTypeId === Constants.ScheduleTypes.ENERGY) {
                        setContractedPower(jsonRes.power.toString())
                        setElectricitySupplyDate(jsonRes.powerStartDate ? dayjs(jsonRes.powerStartDate) : null)
                    }
    
                } else {
                    showErrorToast(strings.getScheduleDetailsError)
    
                    setSchedule(null)
                    resetVariables()
                } 
            }, 1000)
    
        }).catch((error) => {
            setTimeout(() => {
                setIsLoading(false)
                showErrorToast(error)

                setSchedule(null)
                resetVariables()
            }, 1000) 
        })
    }

    // Handle get non possible days
    const getExcludedDates = (harborId) => {
        fetch(`/api/Schedule/${harborId}/NonPossibleDays`, {
            method:'GET',
            headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json; charset=UTF-8',
            'Authorization': 'Bearer ' + loggedUser.jwtToken
            }, 
            mode: 'cors'
        }).then(async response => {
            if (response.status === 200) {
                const jsonRes = await response.json()

                let noPossibleDates = []

                jsonRes.map((date) => {
                    noPossibleDates.push(new Date(date))
                })
              
                setExcludedDates(noPossibleDates)
            } else {
                setTimeout(() => {
                    setIsLoading(false)
                    showErrorToast(strings.getExcludedDatesError)
    
                    setExcludedDates([])
                }, 1000)  
            }

        }).catch((error) => {
            setTimeout(() => {
                setIsLoading(false)
                showErrorToast(error)

                setExcludedDates([])
            }, 1000)   
        })
    }

    // Handle changes in date input for put to dry date
    const onChangePutToDryDate = (selectedDate, context) => {
        if(context.validationError === 'invalidDate' || context.validationError === 'disablePast') {
            setPutToDryDateSelected(false)
        } else if (!selectedDate) {
            setPutToDryDateSelected(false)
        } else {
            setPutToDryDate(selectedDate)
            setPutToDryDateSelected(true)

            if(Object.keys(selectedPutToDryStartTime).length > 0) {
                setStayStartDate(getDate(selectedDate, selectedPutToDryStartTime))
            }
        }
    }

    // Handle when date is selected in date input for put to dry date
    const onAcceptPutToDryDate = (selectedDate) => {
        setPutToDryDate(selectedDate)
        setPutToDryDateSelected(true)

        if(Object.keys(selectedPutToDryStartTime).length > 0) {
            setStayStartDate(getDate(selectedDate, selectedPutToDryStartTime))
        }
    }

    // Handle errors in date input for put to dry date
    const onErrorPutToDryDate = (error) => {
        if(error) {
            setPutToDryDateError(strings.invalidDate)
        } else {
            setPutToDryDateError(null)
        }
    }

    // Handle changes in time input for put to dry start time
    const onChangePutToDryStartTime = (item) => {
        setSelectedPutToDryStartTime(item)
        setStayStartDate(getDate(putToDryDate, item))
    }

    // Handle changes in date input for put to swim date
    const onChangePutToSwimDate = (selectedDate, context) => {
        if(context.validationError === 'invalidDate' || context.validationError === 'disablePast') {
            setPutToSwimDateSelected(false)
        } else if (!selectedDate) {
            setPutToSwimDateSelected(false)
        } else {
            setPutToSwimDate(selectedDate)
            setPutToSwimDateSelected(true)

            if(Object.keys(selectedPutToSwimStartTime).length > 0) {
                setStayEndDate(getDate(selectedDate, selectedPutToDryStartTime))
            }
        }
    }

    // Handle when date is selected in date input for put to swim date
    const onAcceptPutToSwimDate = (selectedDate) => {
        setPutToSwimDate(selectedDate)
        setPutToSwimDateSelected(true)
    }

    // Handle errors in date input for put to swim date
    const onErrorPutToSwimDate = (error) => {
        if(error) {
            setPutToSwimDateError(strings.invalidDate)
        } else {
            setPutToSwimDateError(null)
        }
    }

    // Handle changes in time input for put to swim start time
    const onChangePutToSwimStartTime = (item) => {
        setSelectedPutToSwimStartTime(item)
        setStayEndDate(getDate(putToSwimDate, item))
    }

    // Handle changes in date input for line change date
    const onChangeLineChangeDate = (selectedDate, context) => {
        if(context.validationError === 'invalidDate' || context.validationError === 'disablePast') {
            setLineChangeDateSelected(false)
        } else if (!selectedDate) {
            setLineChangeDateSelected(false)
        } else {
            setLineChangeDate(selectedDate)
            setLineChangeDateSelected(true)
        }
    }

    // Handle when date is selected in date input for line change date
    const onAcceptLineChangeDate = (selectedDate) => {
        setLineChangeDate(selectedDate)
        setLineChangeDateSelected(true)
    }

    // Handle errors in date input for line change date
    const onErrorLineChangeDate = (error) => {
        if(error) {
            setLineChangeDateError(strings.invalidDate)
        } else {
            setLineChangeDateError(null)
        }
    }

    // Handle changes in date input for supply personnel date
    const onChangeSupplyPersonnelDate = (selectedDate, context) => {
        if(context.validationError === 'invalidDate' || context.validationError === 'disablePast') {
            setSupplyPersonnelDateSelected(false)
        } else if (!selectedDate) {
            setSupplyPersonnelDateSelected(false)
        } else {
            setSupplyPersonnelDate(selectedDate)
            setSupplyPersonnelDateSelected(true)
        }
    }

    // Handle when date is selected in date input for supply personnel date
    const onAcceptSupplyPersonnelDate = (selectedDate) => {
        setSupplyPersonnelDate(selectedDate)
        setSupplyPersonnelDateSelected(true)
    }

    // Handle errors in date input for suply personnel date
    const onErrorSupplyPersonnelDate = (error) => {
        if(error) {
            setSupplyPersonnelDateError(strings.invalidDate)
        } else {
            setSupplyPersonnelDateError(null)
        }
    }

    // Handle changes in date input for ripping date
    const onChangeRippingDate = (selectedDate, context) => {
        if(context.validationError === 'invalidDate' || context.validationError === 'disablePast') {
            setRippingDateSelected(false)
        } else if (!selectedDate){
            setRippingDateSelected(false)
        } else {
            setRippingDate(selectedDate)
            setRippingDateSelected(true)
        }
    }

    // Handle when date is selected in date input for ripping date
    const onAcceptRippingDate = (selectedDate) => {
        setRippingDate(selectedDate)
        setRippingDateSelected(true)
    }

    // Handle errors in date input for ripping date
    const onErrorRippingDate = (error) => {
        if(error) {
            setRippingDateError(strings.invalidDate)
        } else {
            setRippingDateError(null)
        }
    }

    // Handle changes in service description input text
    const onChangeServiceDescription = (descriptionText) => {
        setRippingServiceDescription(descriptionText.target.value)
    }

    // Handle changes in date input for mooring start date
    const onChangeMooringStartDate = (selectedDate, context) => {
        if(context.validationError === 'invalidDate' || context.validationError === 'disablePast') {
            setMooringStartDateSelected(false)
        } else if (!selectedDate){
            setMooringStartDateSelected(false)
        } else {
            setMooringStartDate(selectedDate)
            setMooringStartDateSelected(true)
        }
    }

    // Handle when date is selected in date input for mooring start date
    const onAcceptMooringStartDate = (selectedDate) => {
        setMooringStartDate(selectedDate)
        setMooringStartDateSelected(true)
    }

    // Handle errors in date input for mooring start date
    const onErrorMooringStartDate = (error) => {
        if(error) {
            setMooringStartDateError(strings.invalidDate)
        } else {
            setMooringStartDateError(null)
        }
    }

    // Handle changes in date input for mooring end date
    const onChangeMooringEndDate = (selectedDate, context) => {
        if(context.validationError === 'invalidDate' || context.validationError === 'disablePast') {
            setMooringEndDateSelected(false)
        } else if (!selectedDate) {
            setMooringEndDateSelected(false)
        } else {
            setMooringEndDate(selectedDate)
            setMooringEndDateSelected(true)
        }
    }

    // Handle when date is selected in date input for mooring end date
    const onAcceptMooringEndDate = (selectedDate) => {
        setMooringEndDate(selectedDate)
        setMooringEndDateSelected(true)
    }

    // Handle errors in date input for mooring end date
    const onErrorMooringEndDate = (error) => {
        if(error) {
            setMooringEndDateError(strings.invalidDate)
        } else {
            setMooringEndDateError(null)
        }
    }

    // Handle the calculation of the number of days between stay start date and end date
    const getNumberOfDays = () => {
        if(stayStartDate && stayEndDate) {
            const start = dayjs(stayStartDate)
            const end = dayjs(stayEndDate)

            let hours = end.diff(start, 'hours')
            const days = Math.floor(hours / 24)

            return days + 1
        } else {
            return ''
        }
    }

    // Handle the calculation of the number of days between mooring start date and end date
    const getMooringNumberOfDays = () => {
        if(mooringStartDateSelected && mooringEndDateSelected) {
            let hours = mooringEndDate.diff(mooringStartDate, 'hours')
            const days = Math.floor(hours / 24)

            return days + 1
        } else {
            return ''
        }
    }

    // Handle changes in date input for electricity supply date
    const onChangeElectricitySupplyDate = (selectedDate, context) => {
        if(context.validationError !== 'invalidDate' || context.validationError !== 'disablePast') {
            setElectricitySupplyDate(selectedDate)
        }
    }

    // Handle when date is selected in date input for electricity supply date
    const onAcceptElectricitySupplyDate = (selectedDate) => {
        setElectricitySupplyDate(selectedDate)
    }

    // Handle errors in date input for electricity supply date
    const onErrorElectricitySupplyDate = (error) => {
        if(error) {
            setElectricitySupplyDateError(strings.invalidDate)
        } else {
            setElectricitySupplyDateError(null)
        }
    }

    // Handle changes in contracted power input text
    const onChangeContractedPower = (contractedPowerText) => {
        setContractedPower(contractedPowerText.target.value)
    }

    // Handle changes in reschedule reason input text
    const onChangeRescheduleReason = (reasonText) => {
        setRescheduleReason(reasonText.target.value)
    }

    // Check if a number has decimal part
    const hasHalf = (number) => {
        return number % 1 === 0.5
    }

    // Handle add selected hours to date
    const getDate = (selectedDate, selectedStartTime) => {
        const date = new Date(selectedDate)

        if(hasHalf(selectedStartTime.value)) {
            date.setHours(parseInt(selectedStartTime.value, 10))
            date.setMinutes(30)
            date.setSeconds(0)
            date.setMilliseconds(0)
        } else {
            date.setHours(selectedStartTime.value)
            date.setMinutes(0)
            date.setSeconds(0)
            date.setMilliseconds(0)
        }

        return date.toISOString()
    }

    // Handle date formatting
    const formatDate = (timeStamp) => {
        const date = new Date(timeStamp)
        const day = date.getUTCDate()
        const month = Constants.MONTHS[date.getUTCMonth()]
        const year = date.getUTCFullYear()
        return `${day} de ${month} de ${year}`
    }

    // Handle date formatting
    const formatDate2 = (date) => {
        const selectedDate = new Date(date)
        selectedDate.setHours(new Date().getHours())
        return selectedDate.toISOString()
    }

    // Handles time formatting
    const formatTime = (timeStamp) => {
        const date = new Date(timeStamp)
        const hours = date.getHours()
        const minutes = date.getMinutes()
        return `${hours < 10 ? '0' + hours : hours}:${minutes < 10 ? '0' + minutes : minutes}h`
    }

    // Return start date based on schedule type
    const getStartDate = () => {
        switch(schedule && schedule.scheduleTypeId) {
            case Constants.ScheduleTypes.FAIRING: return stayStartDate

            case Constants.ScheduleTypes.FAIRINGENERGY: return stayStartDate

            case Constants.ScheduleTypes.MOORING: return formatDate2(mooringStartDate)

            case Constants.ScheduleTypes.MOORINGENERGY: return formatDate2(mooringStartDate)

            case Constants.ScheduleTypes.ENERGY: return formatDate2(electricitySupplyDate)

            default: return null
        }
    }

    // Return end date based on schedule type
    const getEndDate = () => {
        switch(schedule && schedule.scheduleTypeId) {
            case Constants.ScheduleTypes.FAIRING: return stayEndDate

            case Constants.ScheduleTypes.FAIRINGENERGY: return stayEndDate

            case Constants.ScheduleTypes.MOORING: return formatDate2(mooringEndDate)

            case Constants.ScheduleTypes.MOORINGENERGY: return formatDate2(mooringEndDate)

            case Constants.ScheduleTypes.ENERGY: return null

            default: return null
        }
    }

    // Check if put to dry and put to swim fields are not empty so the user can click 'Next' or 'Schedule' button
    const allFieldsValid = () => {
        if(putToDryDate && Object.keys(selectedPutToDryStartTime).length > 0 && putToSwimDate && Object.keys(selectedPutToSwimStartTime).length > 0) {
            return true
        } else {
            return false
        }
    }

    // Open supply personnel section and scroll to the end of scrollview
    const openSupplyPersonnelSection = () => {
        setSupplyPersonnelExpanded(!supplyPersonnelExpanded)

        if(!supplyPersonnelExpanded) {
            window.scrollTo({
                top: 1000,
                behavior: 'smooth',
            })
        }  
    }

    // Open ripping section and scroll to the end of scrollview
    const openRippingSection = () => {
        setRippingExpanded(!rippingExpanded)

        if(!rippingExpanded) {
            window.scrollTo({
                top: 1000,
                behavior: 'smooth',
            })
        } 
    }

    // Handle schedule update
    const suggestSchedule = () => {
        setShowSuggestModal(false)
        setIsLoading(true)

        let isDatesCorrect = true

        if(lineChangeDateSelected && (lineChangeDate < putToDryDate || lineChangeDate > putToSwimDate)) {
            isDatesCorrect = false
        }

        if(supplyPersonnelDateSelected && (supplyPersonnelDate < putToDryDate || supplyPersonnelDate > putToSwimDate)) {
            isDatesCorrect = false
        }

        if(rippingDateSelected && (rippingDate < putToDryDate || rippingDate > putToSwimDate)) {
            isDatesCorrect = false
        }

        const dryStartDate = putToDryDate && Object.keys(selectedPutToDryStartTime).length > 0 ? getDate(putToDryDate, selectedPutToDryStartTime) : null
        const swimStartDate = putToSwimDate && Object.keys(selectedPutToSwimStartTime).length > 0 ? getDate(putToSwimDate, selectedPutToSwimStartTime) : null
        const lineChangeStartDate = lineChangeDate && Object.keys(selectedLineChangeStartTime).length > 0 ? getDate(lineChangeDate, selectedLineChangeStartTime) : null
        const supplyPersonnelStartDate = supplyPersonnelDate && Object.keys(selectedSupplyPersonnelStartTime).length > 0 ? getDate(supplyPersonnelDate, selectedSupplyPersonnelStartTime) : null
        const supplyPersonnelEndDate = supplyPersonnelDate && Object.keys(selectedSupplyPersonnelEndTime).length > 0 ? getDate(supplyPersonnelDate, selectedSupplyPersonnelEndTime) : null
        const rippingStartDate = rippingDate && Object.keys(selectedRippingStartTime).length > 0 ? getDate(rippingDate, selectedRippingStartTime) : null
        const rippingEndDate = rippingDate && Object.keys(selectedRippingEndTime).length > 0 ? getDate(rippingDate, selectedRippingEndTime) : null

        const data = {
            UserId: schedule && schedule.userId,
            BoatId: schedule && schedule.boatId,
            HarborId: schedule && schedule.harborId,
            ScheduleTypeId: schedule && schedule.scheduleTypeId,
            StartDate: getStartDate(),
            EndDate: getEndDate(),
            DryStartDate: dryStartDate,
            SwimStartDate: swimStartDate,
            LineChangeStartDate: lineChangeStartDate,
            SupplyPersonnelStartDate: supplyPersonnelStartDate,
            SupplyPersonnelEndDate: supplyPersonnelEndDate,
            SupplyPersonnel: numberOfMen.length > 0 ? parseInt(numberOfMen) : null,
            RippingStartDate: rippingStartDate,
            RippingEndDate: rippingEndDate,
            RippingDescription: rippingServiceDescription,
            AccessFacilities: [],
            PowerStartDate: electricitySupplyDate ? formatDate2(electricitySupplyDate) : null,
            PowerEndDate: null,
            Power: contractedPower.length > 0 ? parseInt(contractedPower) : null,
            Reason: rescheduleReason.length > 0 ? rescheduleReason : null
        }

        // Suggest schedule
        fetch(`/api/Schedule/${id}/Suggest`, {
            method:'POST',
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json; charset=UTF-8',
              'Authorization': 'Bearer ' + loggedUser.jwtToken
            }, 
            mode: 'cors',
            body: JSON.stringify(data)
        }).then(async response => {
            setTimeout(async () => {
                setIsLoading(false)
                
                if (response.status === 200) {
                    navigate('/backoffice-schedules')
                } else {
                    showErrorToast(strings.suggestScheduleError)
                }
            }, 1000)

        }).catch((error) => {
            setTimeout(() => {
                setIsLoading(false)
                showErrorToast(error)
            }, 1000)   
        })
    }

    const resetVariables = () => {
        setSchedule(null)

        setPutToDryDate(null)
        setPutToDryDateError(null)
        setPutToDryDateSelected(false)
        setSelectedPutToDryStartTime({})

        setPutToSwimDate(null)
        setPutToSwimDateError(null)
        setPutToSwimDateSelected(false)
        setSelectedPutToSwimStartTime({})

        setStayStartDate(null)
        setStayEndDate(null)

        setLineChangeDate(null)
        setLineChangeDateError(null)
        setLineChangeDateSelected(false)
        setSelectedLineChangeStartTime({})

        setSupplyPersonnelDate(null)
        setSupplyPersonnelDateError(null)
        setSupplyPersonnelDateSelected(false)
        setSelectedSupplyPersonnelStartTime({})
        setSelectedSupplyPersonnelEndTime({})
        setNumberOfMen('0')

        setRippingServiceDescription('')
        setRippingDate(null)
        setRippingDateError(null)
        setRippingDateSelected(false)
        setSelectedRippingStartTime({})
        setSelectedRippingEndTime({})

        setMooringStartDate(null)
        setMooringStartDateError(null)
        setMooringStartDateSelected(false)
        setMooringEndDate(null)
        setMooringEndDateError(null)
        setMooringEndDateSelected(false)

        setContractedPower('')
        setElectricitySupplyDate(null)
        setElectricitySupplyDateError(null)
    }

    // Handle show error toast
    const showErrorToast = (error) => {
        toast.error(error, {
            position: 'top-right',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: false,
            progress: undefined,
            theme: 'colored'
        })
    }

    return (
        <>
            <TopNavBar />

            { isLoading ?
                <div className='h-screen'>
                    <LoadingModal />
                </div>
            :   <div className='min-h-screen mb-6'>
                    <div className='flex flex-col px-[12.5rem]'>
                        <div className='flex flex-row items-center mt-16 mb-10 space-x-2'>
                            <button onClick={() => navigate(-1)}>
                                <img className='h-5 w-5' src={arrow} alt='Voltar atrás'/>
                            </button>
                            <p className='font-montserrat font-semibold text-accent'>{strings.updateSchedule}</p>
                        </div>

                        { schedule && (schedule.scheduleTypeId === Constants.ScheduleTypes.MOORING || schedule.scheduleTypeId === Constants.ScheduleTypes.MOORINGENERGY) ?
                            <>
                                <SectionHeaderView 
                                    text={strings.mooring}
                                    margin={24}
                                />

                                <p className='font-montserrat text-sm px-4'>{strings.dateInfo}</p>

                                <div className='flex flex-row space-x-6 px-4 mt-8 mb-10'>
                                    <div className='flex flex-col w-2/6'>
                                        <p className='font-montserrat text-sm font-semibold mb-1.5'>{strings.startDate}</p>
                                        <DatePickerInput 
                                            maxDate={maxDate}
                                            value={mooringStartDate}
                                            onChange={onChangeMooringStartDate}
                                            onAccept={onAcceptMooringStartDate}
                                            onError={onErrorMooringStartDate}
                                            disabledDates={excludedDates}
                                        />
                                        <p className='font-montserrat text-sm font-medium text-negative mt-1.5 h-2'>{mooringStartDateError ? mooringStartDateError : ''}</p>
                                    </div>

                                    <div className='flex flex-col w-2/6'>
                                        <p className='font-montserrat text-sm font-semibold mb-1.5'>{strings.endDate}</p>
                                        <DatePickerInput
                                            minDate={mooringStartDate}
                                            maxDate={maxDate}
                                            value={mooringEndDate}
                                            onChange={onChangeMooringEndDate}
                                            onAccept={onAcceptMooringEndDate}
                                            onError={onErrorMooringEndDate}
                                            disabled={mooringStartDateSelected ? false : true}
                                            disabledDates={excludedDates}
                                        />
                                        <p className='font-montserrat text-sm font-medium text-negative mt-1.5 h-2'>{mooringEndDateError ? mooringEndDateError : ''}</p>
                                    </div>

                                    <div className='flex flex-col w-2/6'>
                                        <p className='font-montserrat text-sm font-semibold'>{strings.durationInDays}</p>
                                        <div className='py-2 px-3 bg-anti-flash-white rounded mt-1.5 h-10'>
                                            <p className='font-montserrat'>{getMooringNumberOfDays()}</p>
                                        </div>
                                    </div>
                                </div>
                            </>
                        : null }

                        { schedule && (schedule.scheduleTypeId === Constants.ScheduleTypes.FAIRING || schedule.scheduleTypeId === Constants.ScheduleTypes.FAIRINGENERGY) ? 
                            <>
                                <SectionHeaderView 
                                    text={strings.fairing}
                                    margin={24}
                                />

                                <p className='font-montserrat text-sm px-4'>
                                    {strings.requiredInfo}
                                    <span className='text-negative'> * </span>
                                    {strings.requiredInfo2}
                                </p>
                                <p className='font-montserrat text-sm px-4'>{strings.dateInfo}</p>

                                <div className='mt-8 px-4'>
                                    <p className='font-montserrat text-sm font-semibold text-accent'>{strings.putToDry}</p>
                                    <div className='flex flex-row mt-4 space-x-6'>
                                        <div className='flex flex-col w-1/2'>
                                            <p className='font-montserrat text-sm font-semibold mb-1.5'>
                                                {strings.date}
                                                <span className='text-negative'> * </span>
                                            </p>
                                            <DatePickerInput
                                                minDate={dayjs(new Date())}
                                                maxDate={maxDate}
                                                value={putToDryDate}
                                                onChange={onChangePutToDryDate}
                                                onAccept={onAcceptPutToDryDate}
                                                onError={onErrorPutToDryDate}
                                                disabledDates={excludedDates}
                                            />
                                            <p className='font-montserrat text-sm font-medium text-negative mt-1.5 h-2'>{putToDryDateError ? putToDryDateError : ''}</p>
                                        </div>

                                        <div className='flex flex-col w-1/2'>
                                            <p className='font-montserrat text-sm font-semibold'>
                                                {strings.startTime}
                                                <span className='text-negative'> * </span>
                                            </p>
                                            <DropdownInput
                                                options={Constants.TIMES}
                                                value={selectedPutToDryStartTime}
                                                onChange={onChangePutToDryStartTime}
                                                disabled={putToDryDateSelected ? false : true}
                                            />
                                        </div>
                                    </div>

                                    <div className='h-px bg-neutral3 my-9'/>

                                    <p className='font-montserrat text-sm font-semibold text-accent'>
                                        {strings.putToSwim}
                                        <span className='text-negative'> * </span>
                                    </p>
                                    <div className='flex flex-row mt-4 space-x-6'>
                                        <div className='flex flex-col w-1/2'>
                                            <p className='font-montserrat text-sm font-semibold mb-1.5'>{strings.date}</p>
                                            <DatePickerInput 
                                                minDate={putToDryDate}
                                                maxDate={maxDate}
                                                value={putToSwimDate}
                                                onChange={onChangePutToSwimDate}
                                                onAccept={onAcceptPutToSwimDate}
                                                onError={onErrorPutToSwimDate}
                                                disabledDates={excludedDates}
                                            />
                                            <p className='font-montserrat text-sm font-medium text-negative mt-1.5 h-2'>{putToSwimDateError ? putToSwimDateError : ''}</p>
                                        </div>

                                        <div className='flex flex-col w-1/2'>
                                            <p className='font-montserrat text-sm font-semibold'>
                                                {strings.startTime}
                                                <span className='text-negative'> * </span>
                                            </p>
                                            <DropdownInput
                                                options={Constants.TIMES}
                                                value={selectedPutToSwimStartTime}
                                                onChange={onChangePutToSwimStartTime}
                                                disabled={putToSwimDateSelected ? false : true}
                                            />
                                        </div>
                                    </div>

                                    <div className='h-px bg-neutral3 my-9'/>

                                    <p className='font-montserrat text-sm font-semibold text-accent'>{strings.lineChange}</p>

                                    <div className='flex flex-row mt-4 space-x-6'>
                                        <div className='flex flex-col w-1/2'>
                                            <p className='font-montserrat text-sm font-semibold mb-1.5'>{strings.date}</p>
                                            <DatePickerInput 
                                                minDate={putToDryDate ? putToDryDate : dayjs(new Date())}
                                                maxDate={putToSwimDate ? putToSwimDate : maxDate}
                                                value={lineChangeDate}
                                                onChange={onChangeLineChangeDate}
                                                onAccept={onAcceptLineChangeDate}
                                                onError={onErrorLineChangeDate}
                                                disabledDates={excludedDates}
                                            />
                                            <p className='font-montserrat text-sm font-medium text-negative mt-1.5 h-2'>{lineChangeDateError ? lineChangeDateError : ''}</p>
                                        </div>

                                        <div className='flex flex-col w-1/2'>
                                            <p className='font-montserrat text-sm font-semibold'>{strings.startTime}</p>
                                            <DropdownInput
                                                options={Constants.TIMES}
                                                value={selectedLineChangeStartTime}
                                                onChange={(item) => setSelectedLineChangeStartTime(item)}
                                                disabled={lineChangeDateSelected ? false : true}
                                            />
                                        </div>
                                    </div>

                                    <div className='h-px bg-neutral3 my-9'/>

                                    <p className='font-montserrat text-sm font-semibold text-accent'>{strings.stay}</p>
                                    <div className='flex flex-row mt-4 space-x-6'>
                                        <div className='flex flex-col w-2/6'> 
                                            <p className='font-montserrat text-sm font-semibold'>{strings.startDate}</p>
                                            <div className='py-2 px-3 bg-anti-flash-white rounded mt-1.5 h-10'>
                                                <p className='font-montserrat'>{stayStartDate ? formatDate(stayStartDate) : ''}</p>
                                            </div>
                                        </div>

                                        <div className='flex flex-col w-2/6'>
                                            <p className='font-montserrat text-sm font-semibold'>{strings.endDate}</p>
                                            <div className='py-2 px-3 bg-anti-flash-white rounded mt-1.5 h-10'>
                                                <p className='font-montserrat'>{stayEndDate ? formatDate(stayEndDate) : ''}</p>
                                            </div>
                                        </div>

                                        <div className='flex flex-col w-2/6'>
                                            <p className='font-montserrat text-sm font-semibold'>{strings.numberOfDays}</p>
                                            <div className='py-2 px-3 bg-anti-flash-white rounded mt-1.5 h-10'>
                                                <p className='font-montserrat'>{getNumberOfDays()}</p>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='h-px bg-neutral3 mt-9' style={{ marginBottom: supplyPersonnelExpanded ? 36 : 24 }}/>

                                    <div className='flex flex-row items-center justify-between cursor-pointer' onClick={openSupplyPersonnelSection}>
                                        <p className='font-montserrat text-sm font-semibold text-accent'>{strings.supplyPersonnel}</p>
                                        <img className='h-5 w-5 me-4' src={supplyPersonnelExpanded ? arrowUp : arrowDown} alt='Voltar atrás'/>
                                    </div>

                                    { supplyPersonnelExpanded ?
                                        <div className='flex flex-row mt-4 space-x-6'>
                                            <div className='flex flex-col w-2/6'>
                                                <p className='font-montserrat text-sm font-semibold mb-1.5'>{strings.date}</p>
                                                <DatePickerInput 
                                                    minDate={putToDryDate ? putToDryDate : dayjs(new Date())}
                                                    maxDate={putToSwimDate ? putToSwimDate : maxDate}
                                                    value={supplyPersonnelDate}
                                                    onChange={onChangeSupplyPersonnelDate}
                                                    onAccept={onAcceptSupplyPersonnelDate}
                                                    onError={onErrorSupplyPersonnelDate}
                                                    disabledDates={excludedDates}
                                                />
                                                <p className='font-montserrat text-sm font-medium text-negative mt-1.5 h-2'>{supplyPersonnelDateError ? supplyPersonnelDateError : ''}</p>
                                            </div>

                                            <div className='flex flex-col w-2/6'>
                                                <p className='font-montserrat text-sm font-semibold'>{strings.startTime}</p>
                                                <DropdownInput
                                                    options={Constants.TIMES}
                                                    value={selectedSupplyPersonnelStartTime}
                                                    onChange={(item) => setSelectedSupplyPersonnelStartTime(item)}
                                                    disabled={supplyPersonnelDateSelected ? false : true}
                                                />
                                            </div>

                                            <div className='flex flex-col w-2/6'>
                                                <p className='font-montserrat text-sm font-semibold'>{strings.endTime}</p>
                                                <DropdownInput
                                                    options={Constants.TIMES.filter(time => time.value > selectedSupplyPersonnelStartTime.value)}
                                                    value={selectedSupplyPersonnelEndTime}
                                                    onChange={(item) => setSelectedSupplyPersonnelEndTime(item)}
                                                    disabled={Object.keys(selectedSupplyPersonnelStartTime).length > 0 ? false : true}
                                                />
                                            </div>

                                            <div className='flex flex-col w-2/6'>
                                                <p className='font-montserrat text-sm font-semibold'>{strings.numberOfMen}</p>
                                                <input 
                                                    id='nrOfMen' 
                                                    type='number'
                                                    min='0'
                                                    value={numberOfMen}
                                                    onChange={(event) => setNumberOfMen(event.target.value)}
                                                    className='focus:outline-1 focus:outline-accent py-2.5 px-3 gap-2.5 self-stretch border border-neutral5 rounded mt-1.5 font-montserrat h-10'
                                                />
                                            </div>
                                        </div>
                                    : null }

                                    <div className='h-px bg-neutral3' style={{ marginTop: supplyPersonnelExpanded ? 36 : 24, marginBottom: rippingExpanded ? 36 : 24 }}/>

                                    <div className='flex flex-row items-center justify-between cursor-pointer' onClick={openRippingSection}>
                                    <p className='font-montserrat text-sm font-semibold text-accent'>{strings.ripping}</p>
                                        <img className='h-5 w-5 me-4' src={rippingExpanded ? arrowUp : arrowDown} alt='Voltar atrás'/>
                                    </div>

                                    { rippingExpanded ?
                                        <div className='flex flex-col mt-4'>
                                            <label htmlFor='description' className='font-montserrat text-sm font-semibold mb-1.5'>{strings.serviceDescription}</label>
                                            <TextAreaInput 
                                                id='description'
                                                type='text'
                                                value={rippingServiceDescription}
                                                placeholder={strings.write}
                                                onChange={onChangeServiceDescription}
                                            />

                                            <div className='flex flex-row mt-9 space-x-6'>
                                                <div className='flex flex-col w-2/6'>
                                                    <p className='font-montserrat text-sm font-semibold mb-1.5'>{strings.date}</p>
                                                    <DatePickerInput 
                                                        minDate={putToDryDate ? putToDryDate : dayjs(new Date())}
                                                        maxDate={putToSwimDate ? putToSwimDate : maxDate}
                                                        value={rippingDate}
                                                        onChange={onChangeRippingDate}
                                                        onAccept={onAcceptRippingDate}
                                                        onError={onErrorRippingDate}
                                                        disabledDates={excludedDates}
                                                    />
                                                    <p className='font-montserrat text-sm font-medium text-negative mt-1.5 h-2'>{rippingDateError ? rippingDateError : ''}</p>
                                                </div>

                                                <div className='flex flex-col w-2/6'>
                                                    <p className='font-montserrat text-sm font-semibold'>{strings.startTime}</p>
                                                    <DropdownInput
                                                        options={Constants.TIMES}
                                                        value={selectedRippingStartTime}
                                                        onChange={(item) => setSelectedRippingStartTime(item)}
                                                        disabled={rippingDateSelected ? false : true}
                                                    />
                                                </div>

                                                <div className='flex flex-col w-2/6'>
                                                    <p className='font-montserrat text-sm font-semibold'>{strings.endTime}</p>
                                                    <DropdownInput
                                                        options={Constants.TIMES.filter(time => time.value > selectedRippingStartTime.value)}
                                                        value={selectedRippingEndTime}
                                                        onChange={(item) => setSelectedRippingEndTime(item)}
                                                        disabled={Object.keys(selectedRippingStartTime).length > 0 ? false : true}
                                                    />
                                                </div>
                                            </div>

                                        </div>
                                    : null }

                                    { rippingExpanded ? <div className='mb-10'/>
                                    :   <div className='h-px bg-neutral3 mt-7 mb-10'/>
                                    }

                                </div>
                            </>
                        : null }

                        { schedule && (schedule.scheduleTypeId === Constants.ScheduleTypes.MOORINGENERGY || schedule.scheduleTypeId === Constants.ScheduleTypes.FAIRINGENERGY || schedule.scheduleTypeId === Constants.ScheduleTypes.ENERGY) ? 
                            <>
                                <SectionHeaderView 
                                    text={strings.electricitySupply}
                                    margin={24}
                                />

                                { schedule && (schedule.scheduleTypeId === Constants.ScheduleTypes.FAIRINGENERGY || schedule.scheduleTypeId === Constants.ScheduleTypes.MOORINGENERGY) ? null
                                :   <p className='font-montserrat text-sm px-4 mb-8'>{strings.dateInfo}</p>
                                }

                                <div className='flex flex-row space-x-6 px-4 mb-10'>
                                    <div className='flex flex-col w-1/2'>
                                        <label htmlFor='contractedPower' className='font-montserrat text-sm font-semibold'>{strings.contractedPower}</label>
                                        <FormInput2
                                            id='contractedPower' 
                                            type='text'
                                            value={contractedPower}
                                            placeholder={strings.insertContractedPower}
                                            onChange={onChangeContractedPower}
                                            text={strings.kw}
                                        />
                                    </div>

                                    <div className='flex flex-col w-1/2'>
                                        <p className='font-montserrat text-sm font-semibold mb-1.5'>{strings.date}</p>
                                        <DatePickerInput
                                            minDate={schedule && schedule.scheduleTypeId === Constants.ScheduleTypes.FAIRINGENERGY ? putToDryDate ? putToDryDate : dayjs(new Date()) : schedule.scheduleTypeId === Constants.ScheduleTypes.MOORINGENERGY ? mooringStartDate ? mooringStartDate : dayjs(new Date()) : dayjs(new Date())}
                                            maxDate={schedule && schedule.scheduleTypeId === Constants.ScheduleTypes.FAIRINGENERGY ? putToSwimDate ? putToSwimDate : maxDate : schedule.scheduleTypeId === Constants.ScheduleTypes.MOORINGENERGY ? mooringEndDate ? mooringEndDate : maxDate : maxDate}
                                            value={electricitySupplyDate}
                                            onChange={onChangeElectricitySupplyDate}
                                            onAccept={onAcceptElectricitySupplyDate}
                                            onError={onErrorElectricitySupplyDate}
                                            disabledDates={excludedDates}
                                        />
                                        <p className='font-montserrat text-sm font-medium text-negative mt-1.5 h-2'>{electricitySupplyDateError ? electricitySupplyDateError : ''}</p>
                                    </div>
                                </div>
                            </>
                        : null }

                        <SectionHeaderView 
                            text={strings.customerCommunication}
                            margin={24}
                        />

                        <div className='flex flex-col px-4'>

                            <label htmlFor='rescheduleReason' className='font-montserrat text-sm font-semibold mb-1.5'>{strings.justifyReschedule}</label>
                            <TextAreaInput 
                                id='rescheduleReason'
                                type='text'
                                value={rescheduleReason}
                                placeholder={strings.write}
                                onChange={onChangeRescheduleReason}
                            />

                            <div className='mt-14 mb-16 flex flex-row space-x-6'>
                                
                                <div className='flex w-60'>
                                    <RoundedButton 
                                        onClick={() => setShowSuggestModal(true)}
                                        text={strings.suggestSchedule}
                                        height={48}
                                        bgColor='#007EB4'
                                        disabled={(schedule && (schedule.scheduleTypeId === Constants.ScheduleTypes.FAIRING || schedule.scheduleTypeId === Constants.ScheduleTypes.FAIRINGENERGY) && !allFieldsValid()) ? true : false}
                                    />
                                </div>

                                <div className='flex w-60'>
                                    <RoundedBorderButton 
                                        text={strings.cancel}
                                        onClick={() => navigate(-1)}
                                        height={48}
                                        fontWeight='700'
                                    />
                                </div>
                                
                            </div>

                        </div>

                    </div>
                </div>
            }
          
            <ConfirmModal
                open={showSuggestModal}
                onClose={() => setShowSuggestModal(false)}
                title={strings.suggestSchedule2}
                message={strings.suggestScheduleMessage}
                buttonText1={strings.cancel}
                buttonText2={strings.confirmSuggestion}
                onClick={suggestSchedule}
            />

            <ToastContainer />
        </>
    )
}

export default SuggestSchedule